import React from 'react';
import Block from '~/components/ui/block/Block';
import AnonymousImage from '~/assets/anonymous.png';
import Button from '~/components/ui/button/Button';
import { styled } from "styled-components";

const LetsStartBlock = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  
  .letsStart_form {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    
    max-width: 40%;
    
    .form {
      width: unset;
      max-width: 400px;
      margin-left: auto;
      margin-right: auto;
      
      strong {
        letter-spacing: .2rem;
        
        font-size: 14px;
        font-weight: 600;
        line-height: 16.44px;
        letter-spacing: 0.1em;
        text-align: left;
      }
      
      h3 {
        margin-top: 6px;
        font-family: Recoleta;
        font-size: 24px;
        font-weight: 800;
        line-height: 32.64px;
        text-align: left;
      }
      
      .wz_btn {
        margin-top: 12px;
        display: flex;
        justify-content: space-between;

        button {
          width: 48%;
          min-width: 140px;
          margin: 3px;
        }
        
        a {
          border: 0px solid;
          border-radius: 10px;
          background: #9738FF;
          // height: 32px;
          // height: 46px;
          padding: 0px;
          color: #FFF;
          text-align: center;
          
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          cursor: pointer;
          width: 48%;
          min-width: 140px;
          margin: 3px;
          padding-top: 14px;
          text-decoration: none;
        }
      }
    }
  }
  .letsStart_right_image {
    flex: 1;
    text-align: center;
    padding-bottom: 60px;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
    img {;
      width: 100%;
    }
  }
`;

const Anonymous = ({ skipEvent }) => {
  const dashboardUrl = process.env.REACT_APP_DASHBOARD_BASE_URL || 'https://dashboard.easyllama.com'

  return (
    <Block>
      <LetsStartBlock>
        <div className='letsStart_form'>
          <div className='form'>
            <strong>BETTER TOGETHER</strong>
            <h3>Workplace Violence Prevention Training + Anonymous Reporting</h3>
            <p>Protect your team with our Anonymous Reporting tool, designed for state compliance. Empower employees to report safety concerns without fear. Boost trust, ensure confidentiality, and foster a safer workplace. Easy integration and user-friendly interface make compliance effortless. Contact us for more info.</p>
            <div className='wz_btn'>
              <Button onClick={skipEvent} title='Skip' className='' />
              <a href={`${dashboardUrl}/companies/contact`} target='_blank' rel="noreferrer">Contact us</a>
            </div>
          </div>
        </div>
        <div className='letsStart_right_image'>
          <img src={AnonymousImage} alt='Custom courses and Anonymous Feedback form' />
        </div>
      </LetsStartBlock>
    </Block>
  );
};

export default Anonymous;
